import { combineReducers } from "redux";

import { tableBodyConstants } from "../../../actions/deadlines/table/tableBody";

function isSendingNotify(state, { type }) {
  let defaultState = typeof state === "undefined" ? false : state;
  switch (type) {
  case tableBodyConstants.SEND_NOTIFY_V2_START:
    return true;
  case tableBodyConstants.SEND_NOTIFY_V2_SUCCESS:
  case tableBodyConstants.SEND_NOTIFY_V2_ERROR:
    return false;
  default:
    return defaultState;
  }
}

export const notify = combineReducers({
  isSendingNotify
});

export default notify;
